{
  "title": "ตรวจสอบด้วยตนเอง",
  "subtitle": "คำสั่งซื้อที่ถูกระงับในขั้นตอน ingest เนื่องจาก merchant SKU ยังไม่มีการ map กับ Sino กรุณา map SKU และลองอีกครั้ง",
  "col_order": "คำสั่งซื้อ",
  "col_channel": "ช่องทาง",
  "col_created": "สร้างเมื่อ",
  "col_sku": "SKU ที่ยังไม่ได้ map",
  "col_resolve": "แก้ไข",
  "ph_sino": "Sino SKU",
  "btn_resolve_retry": "บันทึกและลองใหม่",
  "err_sino_required": "กรุณาระบุ Sino SKU",
  "err_unknown_sino": "ไม่พบ Sino SKU ในทะเบียน SKU",
  "toast_retried": "คำสั่งซื้อ {{id}} ถูกส่งกลับเข้าคิว ingest แล้ว",
  "toast_next_sku": "บันทึกการ map แล้ว — คำสั่งซื้อมี SKU ที่ยังไม่ได้ map อีกรายการ",
  "toast_not_retryable": "คำสั่งซื้อไม่สามารถลองใหม่ได้อีก คิวถูกรีเฟรชแล้ว",
  "empty": "คิวว่าง — ไม่มีคำสั่งซื้อที่รอการตรวจสอบ",
  "loading": "กำลังโหลดคิวตรวจสอบ…",
  "error": "โหลดคิวตรวจสอบไม่สำเร็จ",
  "btn_retry_all": "ลองใหม่ทั้งหมด",
  "toast_bulk_done": "ส่งกลับเข้าคิว {{attempted}} คำสั่งซื้อ: {{locked}} ล็อกแล้ว, {{stillHeld}} ยังถูกระงับ",
  "toast_bulk_empty": "ไม่มีคำสั่งซื้อที่ถูกระงับในขั้นตอน ingest — ไม่มีอะไรให้ลองใหม่",
  "toast_bulk_failed": "ลองใหม่แบบกลุ่มไม่สำเร็จ — กรุณาลองอีกครั้ง",
  "readonly_hint": "การแก้ไขต้องใช้สิทธิ์เขียน"
}
